export default __webpack_public_path__ + "static/garamond-medium-9fffe100b9e00c2ea8053a7721c436a9.woff2";